import {ReactNode} from "react";

type Props = { header: ReactNode}
function PageHeader(props:Props){
    return (
        <div className="h-60 min-h-60 max-h-60 flex bg-blue-500">
            {props.header}
        </div>
    );
}

export default PageHeader;